// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { GenericQueries } from '../../../../types/server/modules/generic/queries';

export type * from '../../../../types/server/modules/generic/queries';

export const createQueries = ( requests: Requests ): GenericQueries => ({
  CronjobsSubscriptionsById: ( id, query, headers ) => { 
          return requests.get( `/cronjobs/subscriptions/${id}`, query, headers ); 
        },
  CronjobsSubscriptions: ( params?, headers? ) => {
        return requests.get( `/cronjobs/subscriptions/:id?`, params, headers );
      },
  ErroredStreamsById: ( id, query, headers ) => { 
          return requests.get( `/errored-streams/${id}`, query, headers ); 
        },
  ErroredStreams: ( params?, headers? ) => {
        return requests.get( `/errored-streams/:id?`, params, headers );
      }
});
